module.exports = __webpack_public_path__ + "static/media/feature-tick.37c64d86.svg";